import { object } from 'yup';

import { mandatoryErrMessage } from '@constants/validationConstants';

export const schema = object({
	vendor: object().nullable().required(mandatoryErrMessage('Vendor')),
	technology: object().nullable().required(mandatoryErrMessage('Technology')),
});
